import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TOGGLE_MOB_LEFT_MENU } from "../actions/types";
import {
  clearQuickSetupPulse,
  getRemainingQuickSetupPulseMs,
  isMobileQuickSetupViewport,
  QUICK_SETUP_PULSE_EVENT,
} from "../utils/quickSetupPulse";

const PULSE_BODY_CLASS = "quick-setup-pulse-active";

const useQuickSetupPulse = () => {
  const dispatch = useDispatch();
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    let timeoutId;
    let scrollId;

    const stopPulse = () => {
      document.body.classList.remove(PULSE_BODY_CLASS);
      setShowHint(false);
      clearQuickSetupPulse();
    };

    const startPulse = (durationMs) => {
      if (!durationMs) {
        return;
      }

      const mobile = isMobileQuickSetupViewport();
      const desktopHint = window.matchMedia("(min-width: 992px)").matches;

      document.body.classList.remove(PULSE_BODY_CLASS);
      void document.body.offsetWidth;
      document.body.classList.add(PULSE_BODY_CLASS);
      setShowHint(desktopHint);

      if (mobile) {
        dispatch({
          type: TOGGLE_MOB_LEFT_MENU,
          payload: "active",
        });
        window.clearTimeout(scrollId);
        scrollId = window.setTimeout(() => {
          document
            .querySelector(".admin-sidebar--mobile .setupmenuicon")
            ?.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }, 320);
      }

      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(stopPulse, durationMs);
    };

    const onPulse = () => startPulse(getRemainingQuickSetupPulseMs());
    window.addEventListener(QUICK_SETUP_PULSE_EVENT, onPulse);
    startPulse(getRemainingQuickSetupPulseMs());

    return () => {
      window.removeEventListener(QUICK_SETUP_PULSE_EVENT, onPulse);
      window.clearTimeout(timeoutId);
      window.clearTimeout(scrollId);
      document.body.classList.remove(PULSE_BODY_CLASS);
    };
  }, [dispatch]);

  return { showHint };
};

export default useQuickSetupPulse;
